module.exports = __webpack_public_path__ + "static/img/1_1_2.ea4c3f81.jpg";